export function useURL() {
    const getHashParams = () => {
        var h = window.location.hash
        var s = h.replace("#", "")
        return new URLSearchParams(s)
    }

    const getSearchParams = () => {
        var s = window.location.location
        return new URLSearchParams(s)
    }

    const getParameterByName = (name) => {
        const params = new URLSearchParams(location.search)
        return params.get(name)
    }

    /*const setParameterByName = (name, value) => {
        const params = new URLSearchParams(location.search)
        params.set(name, value)
    }*/

    const updateQueryStringParam = (key, value) => {
        var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            newParam = key + '=' + value,
            params = '?' + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            var keyRegex = new RegExp('([\\?&])' + key + '[^&]*')

            // If param exists already, update it
            if (urlQueryString.match(keyRegex) !== null) {
                params = urlQueryString.replace(keyRegex, "$1" + newParam)
            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam
            }
        }
        window.history.replaceState({}, "", baseUrl + params)
    }

    const flushHash = () => {
        window.location.hash = ""
    }
    return {getHashParams, getSearchParams, flushHash, getParameterByName, updateQueryStringParam};
}